import React, { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useForm, setValue } from "react-hook-form";
import * as actions from '../actions/secmasteractions'
import { checkAccess } from '../../../actions/securityactions'




export default function GroupMenus() {

    const state = useSelector(state => state.secmasterReducer);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    let checkPermissions = state.checkPermissions;
    let groupMenus = state.assignGroupMenus;
    let systemMenus = groupMenus.systemMenus;
    let masters = state.masters;
    const refGroupMenus = useRef(null);
    console.log("systemMenus", systemMenus)

    const onResetGroupMenusSearch = () => { }

    const { register: registerGroupMenusSearch,
        reset: resetGroupMenusSearch, handleSubmit: onSubmitData, setValue: setGroupMenusSearchValue, watch: watchGroupMenusSearch, formState: { errors: errorsGroupMenusSearch } } = useForm();


    useEffect(() => {
        async function CheckPermissions() {
            await dispatch(checkAccess({ pageMenuId: 3 }));
            //await dispatch(actions.getSystemMenus());
            await dispatch(actions.getSecurityMasters());
        }
        CheckPermissions();

    }, []);

    useEffect(() => {
        scrollToBottom();
    }, [systemMenus]);

    const scrollToBottom = () => {
        refGroupMenus.current?.scrollIntoView({ behavior: 'smooth' });
    };

    const handleGroupMenusSearch = (e) => { }

    const onAddNewGroupMenus = async () => {

    }

    const onError = (errorsGroupMenusSearch, e) => console.log(errorsGroupMenusSearch, e);

    const onCollapseSearch = () => {
        if (groupMenus.searchClass === "collapse show") {
            //    dispatch(actions.collapseSearch(true));
        } else {
            //    dispatch(actions.collapseSearch(false));
        }
    }

    const saveAssignGroupMenus = async () => {
        dispatch(actions.saveAssignGroupMenus())
    }
    function resetAssignGroupMenus() {
        dispatch(actions.resetAssignGroupMenus())
    }
    function handleSystemMenuRadioBtnChange(value, e) {
        dispatch(actions.handleSystemMenuRadioBtnChange(value, e.target.checked))
    }
    function handleSystemMenuRadioBtnChangeForSubChild(value, e) {
        dispatch(actions.handleSystemMenuRadioBtnChangeForSubChild(value, e.target.checked))
    }
    function toggleMenuOpen(value, e) {
        dispatch(actions.toggleMenuOpen(value))
    }




    function renderSystemMenus() {
        if (systemMenus.length == 0) {
            return <></>
        }

        return (
            <>

                <div class="list-group col-md-12 scrollspy-example" data-bs-spy="scroll" style={{ height: "750px" }}>
                    {systemMenus.length > 0 && systemMenus.map((parentMenus, index) => (
                        <>
                            <div className=" mb-12 col-md-12">
                                <button type="button" class="list-group-item list-group-item-action" onClick={() => toggleMenuOpen(parentMenus.menuId)}>
                                    <i className={parentMenus.showChild ? " dripicons-chevron-down" : "dripicons-chevron-right"} />&nbsp;{parentMenus.displayName}</button >
                                {parentMenus.showChild && parentMenus.childMenus.length > 0 && parentMenus.childMenus.map((childMenu, index) => (
                                    <>
                                        <div className="mb-12 me-3">
                                            <button type="button" class="list-group-item list-group-item-action ms-3" onClick={() => toggleMenuOpen(childMenu.menuId)}>
                                                <i className={childMenu.showChild ? " dripicons-chevron-down" : "dripicons-chevron-right"} />&nbsp;{childMenu.displayName}</button>
                                            {childMenu.showChild && childMenu.childMenus.length > 0 &&
                                                childMenu.childMenus.map((subChildMenu, index) => (
                                                    <>
                                                        <div className="mb-12 me-2">
                                                            {<button type="button" class={"list-group-item list-group-item-action ms-4" + (subChildMenu.showChild ? " dripicons-chevron-down" : " dripicons-chevron-right")} onClick={() => toggleMenuOpen(subChildMenu.menuId)}>
                                                                &nbsp;
                                                                <input type="checkbox" id={`checkbox_menu${subChildMenu.menuId}`}
                                                                    name={`checkbox_menu${subChildMenu.menuId}`} className="form-check-input"
                                                                    onChange={(e) => handleSystemMenuRadioBtnChangeForSubChild(subChildMenu.menuId, e)}
                                                                    checked={subChildMenu.isChecked}
                                                                />
                                                                <label className="form-check-label" htmlFor={`checkbox_menu${subChildMenu.menuId}`}> &nbsp; {subChildMenu.displayName}</label>
                                                            </button>
                                                            }
                                                            {subChildMenu.showChild && subChildMenu.childMenus.length > 0 &&
                                                                subChildMenu.childMenus.map((actionChildMenu, index) => (

                                                                    <div className="mb-12 me-0">
                                                                        <li class="list-group-item ms-5"><input type="checkbox" id={`checkbox_menu${actionChildMenu.menuId}`}
                                                                            name={`checkbox_menu${actionChildMenu.menuId}`} className="form-check-input"
                                                                            onChange={(e) => handleSystemMenuRadioBtnChange(actionChildMenu.menuId, e)}
                                                                            checked={actionChildMenu.isChecked}
                                                                        />
                                                                            <label className="form-check-label" htmlFor={`checkbox_menu${actionChildMenu.menuId}`}> &nbsp; {actionChildMenu.displayName}</label>
                                                                        </li>
                                                                    </div>
                                                                ))}
                                                        </div>
                                                    </>
                                                ))}
                                        </div>
                                    </>
                                ))
                                }
                            </div>
                        </>
                    ))}
                    {/*<a href="#" class="list-group-item list-group-item-action">Google Drive</a>
                        <button type="button" class="list-group-item list-group-item-action">Facebook Messenger</button>
                        <button type="button" class="list-group-item list-group-item-action">Apple Technology Company</button>
                <a href="#" class="list-group-item list-group-item-action disabled" tabindex="-1" aria-disabled="true">Intercom Support System</a>*/}
                </div >




                {/* systemMenus.length > 0 && systemMenus.map((parentMenus, index) => (
                    <>
                        <div className="mb-12 col-md-12" key={parentMenus.menuId}>
                            <div className="form-check form-check-inline">
                                <input type="checkbox" id={`checkbox_menu${parentMenus.menuId}`}
                                    name={`checkbox_menu${parentMenus.menuId}`} className="form-check-input"
                                    onChange={(e) => c(parentMenus.menuId, e)}
                                    checked={parentMenus.isChecked}
                                  />
                                <label className="form-check-label" htmlFor={`checkbox_menu${parentMenus.menuId}`}>{parentMenus.displayName}</label>
                            </div>
                        </div>
                        {parentMenus.childMenus.length > 0 &&
                            parentMenus.childMenus.map((childMenu, index) => (
                                <>
                                    <div className="ms-3 mb-12 col-md-9" key={childMenu.menuId}>
                                        <div className="form-check form-check-inline">
                                            <input type="checkbox" id={`checkbox_menu${childMenu.menuId}`}
                                                name={`checkbox_menu${childMenu.menuId}`} className="form-check-input"
                                                onChange={(e) => handleSystemMenuRadioBtnChange(childMenu.menuId, e)}
                                                checked={childMenu.isChecked}
                                             />
                                            <label className="form-check-label" htmlFor={`checkbox_menu${childMenu.menuId}`}>{childMenu.displayName}</label>
                                        </div>
                                    </div>
                                    {childMenu.childMenus.length > 0 &&
                                        childMenu.childMenus.map((subChildMenu, index) => (
                                            <div className="ms-5 mb-12 col-md-9" key={subChildMenu.menuId}>
                                                <div className="form-check form-check-inline">
                                                    <input type="checkbox" id={`checkbox_menu${subChildMenu.menuId}`}
                                                        name={`checkbox_menu${subChildMenu.menuId}`} className="form-check-input"
                                                        onChange={(e) => handleSystemMenuRadioBtnChange(subChildMenu.menuId, e)}
                                                        checked={subChildMenu.isChecked}
                                                         />
                                                    <label className="form-check-label" htmlFor={`checkbox_menu${subChildMenu.menuId}`}>{subChildMenu.displayName}</label>
                                                </div>
                                            </div>
                                        )
                                        )
                                    }
                                </>
                            )
                            )
                        }
                    </>
                )

                )
                 */}
            </>
        )
    }


    return (

        <>

            <div className="content" ref={refGroupMenus}>
                {/* <div className="row"> */}
                {/* <div className="col-6"> */}
                <div className="card ribbon-box">
                    <div className="card-body">
                        <div className="ribbon ribbon-primary float-start"><i className="dripicons-list me-1"></i>Group Menus</div>

                        <div class="custmcontainer">
                            <div class="left-section">
                                <h5>
                                    {/* <i class="dripicons-view-list"></i> */} System Menus
                                </h5>
                                <hr />
                                <div className="row g-2">
                                    {renderSystemMenus()}

                                </div>
                            </div>

                            {/* <button className='btn btn-primary' type="button" disabled={branchMasters.filter(b => b.isChecked == true).length == 0} onClick={() => moveToUserBranches()}><i class="dripicons-chevron-right " /> </button>
                                    <div className="mb-1" />
                                    <button className='btn btn-primary' type="button" disabled={userBranches.filter(b => b.isChecked == true).length == 0} onClick={() => removeFromUserBranches()}><i class="dripicons-chevron-left " /></button>
                                    */}
                            {/*                                     <div class="right-section">
                                        <h5>
                                          Group Menus
                                        </h5>
                                        <hr />
                                        <div className="row g-2">
                                            {/* renderSelectedMenus() }
                                        </div>
                                    </div> */}
                        </div>
                        <div className="row g-2">
                            <div class="modal-footer">

                                {checkPermissions.hasResetGroupMenus && <button className='btn btn-danger' type="button" onClick={() => resetAssignGroupMenus()} ><i className="mdi mdi-rotate-left" /> Reset</button>}
                                {checkPermissions.hasSaveGroupMenus && <button className='btn btn-success' type="button" onClick={() => saveAssignGroupMenus()} ><i class="dripicons-print"></i> Save</button>}
                            </div>
                        </div>
                    </div>
                </div>
                {/* </div> */}
                {/* </div> */}
            </div>

        </>
    )
}